// Generated by purs version 0.15.16
import * as Control_Extend from "../Control.Extend/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
var extract = function (dict) {
    return dict.extract;
};
export {
    extract
};
export {
    duplicate,
    extend
} from "../Control.Extend/index.js";
export {
    map,
    void
} from "../Data.Functor/index.js";
//# sourceMappingURL=index.js.map
